export default __webpack_public_path__ + "static/media/element_spec_10.544c463e.webp";